import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchGatewaysFailure,
  fetchGatewaysStart,
  fetchGatewaysSuccess,
} from "../../../store/features/customer/instruments/gatewaysSlice";

const URL = `${process.env.REACT_APP_MOCKAPI_URL}/api/v1/field/field/gateways`;

const getGatewaysApi = async (filter = "") => {
  try {
    const response = await axios.get(URL, {
      params: {
        filter: filter || null,
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchGatewaysSaga(action) {
  try {
    const { filter } = action.payload;
    const gatewaysData = yield call(getGatewaysApi, filter);
    yield put(fetchGatewaysSuccess(gatewaysData));
  } catch (error) {
    yield put(fetchGatewaysFailure(error.message));
  }
}

export default function* gatewaysSaga() {
  yield takeLatest(fetchGatewaysStart.type, fetchGatewaysSaga);
}
